import * as z from 'zod';

// Enums

// Where the raw HTML is injected in the hosted page document.
export const customCodePlacementEnum = z.enum([
  'head_start',
  'head_end',
  'body_start',
  'body_end',
]);
export type CustomCodePlacement = z.infer<typeof customCodePlacementEnum>;

// 3. Read schema - all properties nullable (API response)
export const readCustomCodeSchema = z.object({
  id: z.uuid().nullable(),
  name: z.string().nullable(),
  placement: customCodePlacementEnum.nullable(),
  // Raw HTML, injected verbatim (scripts, styles, JSON-LD…).
  code: z.string().nullable(),
  enabled: z.boolean().nullable(),
  position: z.number().nullable(),
  createdAt: z.iso.datetime().nullable(),
  updatedAt: z.iso.datetime().nullable(),
});
export type ReadCustomCode = z.infer<typeof readCustomCodeSchema>;

// 4. Create schema - based on DTO serialization groups
export const createCustomCodeSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(100, 'Name must not exceed 100 characters'),
  placement: customCodePlacementEnum,
  code: z
    .string()
    .min(1, 'Code is required')
    .max(32768, 'Code must not exceed 32,768 characters'),
  enabled: z.boolean().optional(),
});
export type CreateCustomCode = z.infer<typeof createCustomCodeSchema>;

// 5. Update schema - any subset of the create fields
export const updateCustomCodeSchema = createCustomCodeSchema.partial();
export type UpdateCustomCode = z.infer<typeof updateCustomCodeSchema>;

// Reorder payload (PUT …/order): the scope's ids in the new order.
export const reorderCustomCodesSchema = z.object({
  ids: z.array(z.uuid()),
});
export type ReorderCustomCodes = z.infer<typeof reorderCustomCodesSchema>;
